export default { sha: '3a87062dc93996690a4ab073bd85ab93d076bf12', buildNumber: 'undefined' }
